interface SavedArticle {
  id: string;
  saved: boolean | null;
}

interface SaveArticleContext {
  articles: SavedArticle[];
}

const saveArticleContext: SaveArticleContext = { articles: [] };

const fetchAndUpdateSavedArticlesInContext = async () => {
  const response = await fetch("/api/articles/saved-ids");
  const fetchSavedArticleList = (await response.json()) as string[];
  saveArticleContext.articles.forEach((article) => {
    article.saved = !!fetchSavedArticleList.find(
      (savedArticleId) => article.id === savedArticleId
    );
  });
};

const updateDom = () => {
  saveArticleContext.articles.forEach((article) => {
    const element = document.querySelector(`[save-article-button='${article.id}']`);
    if (!element) {
      throw new Error("Can't find article button. This is a bug.");
    }

    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }

    const newIconElement = document.createElement("i");
    newIconElement.classList.add("fa-bookmark");

    if (article.saved) {
      newIconElement.classList.add("fa-solid");
    } else {
      newIconElement.classList.add("fa-regular");
    }

    element.append(newIconElement);
  });
};

const unsaveArticle = async (articleId: string) => {
  const url = `/api/articles/${articleId}/save`;
  const options = { method: "DELETE" };
  await fetch(url, options);
};

const saveArticle = async (articleId: string) => {
  const url = `/api/articles/${articleId}/save`;
  const options = { method: "PUT" };
  await fetch(url, options);
};

const onClickSaveIcon = async (element: Element) => {
  const articleId = element.getAttribute("save-article-button");
  const article = saveArticleContext.articles.find((article) => article.id === articleId);
  if (!article) {
    throw new Error("Can not find article id. This is a bug.");
  }

  if (article.saved) {
    await unsaveArticle(article.id);
    article.saved = false;
  } else {
    await saveArticle(article.id);
    article.saved = true;
  }
  updateDom();
};

document.addEventListener("DOMContentLoaded", async () => {
  const elements = document.querySelectorAll("[save-article-button]");
  if (elements.length <= 0) {
    return;
  }

  elements.forEach((element) => {
    const articleId = element.getAttribute("save-article-button");
    if (articleId) {
      saveArticleContext.articles.push({
        id: articleId,
        saved: null,
      });
    }
  });

  await fetchAndUpdateSavedArticlesInContext();
  updateDom();

  elements.forEach((element) =>
    element.addEventListener("click", () => onClickSaveIcon(element))
  );
});
